module.exports = __webpack_public_path__ + "static/media/DragHandle.1744b77c.svg";